var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getCustomBrandingFromStorage, saveCustomBrandingToStorage, getAccountIdFromStorage, clearCustomBranding } from 'helpers/customBranding';
import { getCustomBranding } from 'services/api/account';
import useQueryString from 'hooks/use-querystring';
import Loader from 'components/loader/loader';
export const CustomBranding = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const queryString = useQueryString();
    useEffect(() => {
        var _a;
        const customBranding = getCustomBrandingFromStorage();
        const accountId = (_a = queryString.get('accountId')) !== null && _a !== void 0 ? _a : getAccountIdFromStorage();
        // Use custom branding already loaded
        if ((customBranding === null || customBranding === void 0 ? void 0 : customBranding.accountId) === accountId) {
            loadBranding(customBranding);
        }
        else {
            getBrandingFromService(accountId);
        }
    }, []);
    const getBrandingFromService = (accountId) => __awaiter(void 0, void 0, void 0, function* () {
        if (accountId) {
            const customBranding = yield getCustomBranding(accountId);
            if (customBranding === null || customBranding === void 0 ? void 0 : customBranding.isEnabled) {
                saveCustomBrandingToStorage(Object.assign(Object.assign({}, customBranding), { accountId }), accountId);
                loadBranding(customBranding);
            }
            else {
                clearCustomBranding();
            }
        }
        setIsLoading(false);
    });
    const loadBranding = (customBranding) => {
        if (!(customBranding === null || customBranding === void 0 ? void 0 : customBranding.isEnabled)) {
            setIsLoading(false);
            return;
        }
        const element = document.querySelector('.sumadi');
        if (!element) {
            setIsLoading(false);
            return;
        }
        const primaryColors = getColors(customBranding.primaryColor);
        if (primaryColors) {
            element.style.setProperty('--color-primary', primaryColors.color);
            primaryColors.dark && element.style.setProperty('--color-primary--dark', primaryColors.dark);
            primaryColors.light && element.style.setProperty('--color-primary--light', primaryColors.light);
        }
        const secondaryColors = getColors(customBranding.secondaryColor);
        if (secondaryColors) {
            element.style.setProperty('--color-secondary', secondaryColors.color);
            secondaryColors.dark && element.style.setProperty('--color-secondary--dark', secondaryColors.dark);
            secondaryColors.light && element.style.setProperty('--color-secondary--light', secondaryColors.light);
        }
        document.body.classList.add('custom-theme');
        setIsLoading(false);
    };
    const getColors = (HSLcolor = '') => {
        const color = HSLcolor.split(', ');
        if (color.length === 3) {
            const lightnessString = color[2].replace('%)', '');
            const lightness = parseInt(lightnessString, 10);
            if (!isNaN(lightness)) {
                return {
                    color: HSLcolor,
                    dark: HSLcolor.replace(lightnessString, `${lightness - 10}`),
                    light: HSLcolor.replace(lightnessString, `${lightness + 10}`),
                };
            }
        }
    };
    return (_jsxs("div", { children: [_jsx("div", { id: "modal" }, void 0), isLoading && _jsx(Loader, { isFullWith: true, gray: true }, void 0), !isLoading && children] }, void 0));
};
